import { FilterModel } from '../../interfaces/ifilter';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
	Component,
	EventEmitter,
	Inject,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core';
import { CriteriaObject } from "../../interfaces/CriteriaModel";

@Component({
	selector: 'app-side-filter',
	templateUrl: './side-filter.component.html',
	styleUrls: ['./side-filter.component.scss'],
})
export class SideFilterComponent implements OnInit, OnChanges {
	@Input() filters: FilterModel[];
	@Input() spinner: boolean = false;
	@Input() ICriteria: CriteriaObject;
	@Output() closeFilter = new EventEmitter<void>();

	@Output() OCriteria = new EventEmitter();
	@Output() clearFilters = new EventEmitter<void>();

	private finalCriteria: Object = {};

	constructor() {
	}

	get isApplyBtnDisbaled() {
		return !!this.filters && this.isSame();
	}

	get isClearBtnDisbaled() {
		return JSON.stringify({}) === JSON.stringify(this.finalCriteria);
	}

	ngOnChanges(changes: SimpleChanges): void {
		// this.finalCriteria = { ...this.ICriteria.defaultCriteria, ...this.ICriteria.updatedCrteria };
		if (changes.ICriteria) {
			this.finalCriteria = { ...this.ICriteria.defaultCriteria, ...this.ICriteria.updatedCrteria };
		}
	}

	ngOnInit(): void {
		this.initializeVariables();
	}

	public onApplyClicked() {
		this.OCriteria.emit(this.finalCriteria);
		this.closeFilter.emit();
	}

	// public onClearClicked() {
	// 	// this.finalCriteria = {...this.ICriteria.defaultCriteria, ...{}};
	// 	this.finalCriteria = { ...this.ICriteria.defaultCriteria };
	// 	/*resetting sliders value*/
	// 	this.filters.map((filter) => {
	// 		if (filter.type === 'slider') {
	// 			filter.options.value = filter.options.options.floor;
	// 		}
	// 	});

	// 	this.OCriteria.emit(this.finalCriteria);
	// 	this.closeFilter.emit();
	// }

	public onClearClicked() {
		this.finalCriteria = { ...this.ICriteria.defaultCriteria };
		this.filters.forEach((filter) => {
			if (filter.type === 'slider') {
				filter.options.value = filter.options.options.floor;
			}
		});
		this.OCriteria.emit(this.finalCriteria);
		this.clearFilters.emit();
		this.closeFilter.emit();
	}


	public handleRadioEvent(key: string, $event: string) {
		if (!key || !$event) {
			return;
		}

		this.finalCriteria = {
			...this.finalCriteria,
			[key]: $event
		};
		this.updateChangeDetection();
	}

	public handleCheckBoxEvent(key: string, $event: string, value: string, hasMultipleOptions?: boolean) {
		if (!key) {
			return;
		}

		let values = (this.finalCriteria[key]) ? this.finalCriteria[key] : [];

		if (hasMultipleOptions) {
			if ($event) {
				values = [...values, $event];
			} else {
				// values = [...values];
				// values.splice(values.findIndex(item => item === value), 1);
				values = values.filter(item => item !== value);
			}

			this.finalCriteria = {
				...this.finalCriteria,
				[key]: values.length ? values : null,
			}
		} else {
			values = ($event) ? $event : null;

			this.finalCriteria = {
				...this.finalCriteria,
				[key]: values,
			}
		}
		this.updateChangeDetection();
	}

	public handleSliderChange(key: string, $event: string) {
		if (!key || !$event) {
			return;
		}

		this.finalCriteria = {
			...this.finalCriteria,
			[key]: $event
		}
		this.updateChangeDetection();
	}

	// public selectedValue(key: string, filterType: string, filterValue = '', hasMultipleOptions?: boolean): any {
	// 	if (this.finalCriteria[key]) {
	// 		switch (filterType) {
	// 			case 'radio':
	// 				if (key === 'primaryMetal.purity') {
	// 					if (this.finalCriteria[key].includes('GOLD_22'))
	// 						return 'GOLD';
	// 					else
	// 						return this.finalCriteria[key][0];
	// 				}
	// 				else
	// 					return this.finalCriteria[key];
	// 				break;

	// 			case 'checkbox':
	// 				if (this.finalCriteria[key] === 'DIAMOND') {
	// 					return true;
	// 				} else if (hasMultipleOptions) {
	// 					return (this.finalCriteria[key].indexOf(filterValue) > -1);
	// 				} else {
	// 					return (this.finalCriteria[key] === filterValue);
	// 				}
	// 				break;

	// 			default:
	// 				return null;
	// 				break;
	// 		}
	// 	}

	// 	return null;
	// }

	// public selectedValue(key: string, filterType: string, filterValue = '', hasMultipleOptions?: boolean): any {

	// 	if (this.finalCriteria[key]) {

	// 		switch (filterType) {
	// 			case 'radio':
	// 				if (key === 'primaryMetal.purity') {
	// 					if (key === 'primaryMetal.purity' && this.finalCriteria[key].includes('GOLD_22')) {
	// 						return 'GOLD';
	// 					} else {
	// 						return this.finalCriteria[key][0];
	// 					}
	// 				} else
	// 					return this.finalCriteria[key];
	// 			// return this.finalCriteria[key];
	// 			case 'checkbox':
	// 				if (this.finalCriteria[key] === 'DIAMOND') {
	// 					return true;
	// 				} else if (hasMultipleOptions) {
	// 					return this.finalCriteria[key].includes(filterValue);
	// 				} else {
	// 					return this.finalCriteria[key] === filterValue;
	// 				}
	// 			default:
	// 				return null;
	// 		}
	// 	}
	// 	return null;
	// }

	public selectedValue(key: string, filterType: string, filterValue = '', hasMultipleOptions?: boolean): any {
		if (this.finalCriteria[key]) {
			let value = this.finalCriteria[key];
			if (filterType === 'radio') {
				if (Array.isArray(value)) {
					value = value[0];
				}
			}
			switch (filterType) {
				case 'radio':
					if (key === 'primaryMetal.purity') {
						if (value === "GOLD" || value.includes('GOLD_22')) {
							return 'GOLD';
						} else {
							if (value === 0) {
								return value;
							} else {
								return value;
							}
						}
					} else {
						return value;
					}
					break;

				// case 'checkbox':
				// 	// if (value === 'DIAMOND') {
				// 	if (value === 'NATURAL') {
				// 		return true;
				// 	} else if (value === "LAB GROWN") {
				// 		return true;
				// 	} else if (hasMultipleOptions) {
				// 		return (value.indexOf(filterValue) > -1);
				// 	} else {
				// 		return (value === filterValue);
				// 	}
				// 	break;

				case 'checkbox':
					if (hasMultipleOptions) {
						return (value.indexOf(filterValue) > -1);
					} else {
						return (value === filterValue);
					}

				default:
					return null;
			}
		}
		return null;
	}


	private isSame() {
		return JSON.stringify({ ...this.ICriteria.defaultCriteria, ...this.ICriteria.updatedCrteria }) === JSON.stringify(this.finalCriteria);
	}

	private initializeVariables() {
		this.finalCriteria = { ...this.ICriteria.defaultCriteria, ...this.ICriteria.updatedCrteria };
	}

	private updateChangeDetection() {
		setTimeout(() => { }, 0);
	}
}
